/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nobusinessesfound2Inputs */

const en_nobusinessesfound2 = /** @type {(inputs: Nobusinessesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No businesses found`)
};

const de_nobusinessesfound2 = /** @type {(inputs: Nobusinessesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Unternehmen gefunden`)
};

/**
* | output |
* | --- |
* | "No businesses found" |
*
* @param {Nobusinessesfound2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nobusinessesfound2 = /** @type {((inputs?: Nobusinessesfound2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nobusinessesfound2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nobusinessesfound2(inputs)
	return de_nobusinessesfound2(inputs)
});
export { nobusinessesfound2 as "noBusinessesFound" }